import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { useContextSelector } from "use-context-selector";

import AuthContext from "../context/AuthContext";
import LayoutNew from "../components/shared/LayoutNew";
import CurrentNews from "../components/CurrentNews";
import GameSlider from "../components/GameSlider";
import FooterSection from "../components/FooterSection";
import MainBanner from "./slider/MainBanner";
import HotGameSlider from "./slider/HotGameSlider";
import SportSilder from "./slider/SportSilder";
import JackpotGameSlider from "./slider/JackpotGameSlider";
import LiveCashino from "./slider/LiveCashino";
import SlotGameSlider from "./slider/SlotGameSlider";
import PokerGameSlider from "./slider/PokerGameSlider";
import FishingGameSlider from "./slider/FishingGameSlider";
import EsportsGameSlider from "./slider/EsportsGameSlider";
import LotteryGameSlider from "./slider/LotteryGameSlider";
import referralIcon from "../assets/images/icon-referral.svg";
import OpeningDialogs from "../components/OpeningDialogs";

import "../styles/home/index.scss";

const HomeNew = () => {
  const navigate = useNavigate();
  const user = useContextSelector(AuthContext, (context) => context.user);
  const messages = useContextSelector(AuthContext, (context) => context.messagelist);
  const setAnnouncement = useContextSelector(
    AuthContext,
    (context) => context.setAnnouncement,
  );
  const showReferral = useContextSelector(
    AuthContext,
    (context) => context.handelShowReferBox,
  );

  useEffect(() => {
    document.body.classList.add("ck-home");

    return () => {
      document.body.classList.remove("ck-home");
    };
  }, []);

  return (
    <LayoutNew>
      {/* {!isEmpty(user) && <OpeningDialogs />} */}
      <div className="home-page-content">
        <CurrentNews message={messages} setAnnouncement={setAnnouncement} />
        {isEmpty(user) && <MainBanner />}

      <div className="refer-box blinkreace" role="button" tabIndex={0} onClick={showReferral} onKeyDown={(event) => event.key === "Enter" && showReferral()}>
        <img src={referralIcon} alt="" />
        <span>Refer</span>
      </div>

      {!isEmpty(user) && (
        <div className="deposit-withdraw">
          <div className="btn-deposit" role="button" tabIndex={0} onClick={() => navigate("/deposit")} onKeyDown={(event) => event.key === "Enter" && navigate("/deposit")}>
            <svg className="am-icon am-icon-icon-deposit_7625b392 am-icon-md">
              <use xlinkHref="#icon-deposit_7625b392" />
            </svg>
            <span>Deposit</span>
          </div>
          <div className="btn-withdraw" role="button" tabIndex={0} onClick={() => navigate("/withdraw")} onKeyDown={(event) => event.key === "Enter" && navigate("/withdraw")}>
            <svg className="am-icon am-icon-icon-withdraw_76d28c0a am-icon-md">
              <use xlinkHref="#icon-withdraw_76d28c0a" />
            </svg>
            <span>Withdraw</span>
          </div>
        </div>
      )}

      <main className="main">
        <GameSlider />
        <HotGameSlider />
        <SportSilder />
        <JackpotGameSlider />
        <LiveCashino />
        <SlotGameSlider />
        <PokerGameSlider />
        <FishingGameSlider />
        <EsportsGameSlider />
        <LotteryGameSlider />
        <FooterSection />
      </main>
      </div>
    </LayoutNew>
  );
};

export default HomeNew;
